<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { usePage } from '@inertiajs/vue3'

const iconModules = import.meta.glob('/node_modules/lucide-vue-next/dist/esm/icons/*.js')
const page = usePage()

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: false,
    default: null,
  },
  href: {
    required: true
  },
  name: null,
})

const iconComponent = computed(() => {
  if (!props.icon) {
    return null
  }

  const filename = props.icon + '.js'
  const importer = iconModules[`/node_modules/lucide-vue-next/dist/esm/icons/${filename}`]

  return importer ? defineAsyncComponent(importer) : null
})

const getHref = (href) => {
  if (href === null) {
    return ''
  }

  const language = page.props.session.language
  const localeHref = href[language] ?? href

  // Check if the href contains auth and guest properties
  if (localeHref && typeof localeHref === 'object' && 'auth' in localeHref && 'guest' in localeHref) {
    // Use auth URL if authenticated, otherwise use guest URL
    return page.props.auth ? localeHref.auth : localeHref.guest
  }

  return localeHref
}
</script>

<template>
  <a
    :href="getHref(href)"
    class="font-normal px-4 py-1.5 sm:whitespace-nowrap sm:font-medium sm:text-sm !sm:underline !no-underline inline-flex gap-1 items-center text-gray-700 hover:text-gray-900 transition-colors duration-200"
  >
    <Component v-if="iconComponent" :is="iconComponent" class="size-4" />
    {{ name }}
  </a>
</template>
